module.exports = __webpack_public_path__ + "img/beneficios.2badd539.jpg";